import {ContentChild, Directive, TemplateRef} from "@angular/core";

@Directive({
    selector: "williams-ui-platform-combobox-templates"
})
export class ComboboxTemplateDirective {
    @ContentChild('comboboxListItemTemplate') comboboxListItemTemplate!: TemplateRef<any>;
}